import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { tags_view } from "../../modules/tags_view";
import { emaki_brand } from "../../utils/types/emaki_brand";

declare var ko: any;

export class tagTypesView_template extends vnTemplate {

    protected getTemplateHtml(): string {

        return /*html*/ `

                <div class="w-form w-form-large view-tag">

                    <div class="form-header">
                        <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                        <h3 class="form-title" data-bind="text: name"></h3>
                        <div>
                            <button data-bind="event: { click: onClickEdit }, visible: permissions()['tag_type_edit'].write" class="btn icon i-edit" type="button">Edit Tag Type</button>
                        </div>
                    </div>


                    <div class="w-form-body">
                        <div class="form-body">
                            <div class="form-group">
                                <dl class="double-list">
                                    <dt>
                                        <span>Name</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: name"></span>
                                    </dd>
                                    <dt>
                                        <span>Product Schema.org Template</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: productSchemaTemplateName"></span>
                                    </dd>
                                    <dt>
                                        <span>Dataset</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: datasetName"></span>
                                    </dd>
                                    <!-- ko if: !brandId() -->
                                    <dt>
                                        <span>Brand Ownership</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: brandOwner()? brandOwner().name : 'None'"></span>
                                        <!-- ko if: brandOwner -->
                                        <span data-bind="attr: { class: brandOwner().iconImage + ' dark square-icon' }"
                                            style="
                                                width:20px;
                                                height:15px;
                                                background-repeat:no-repeat;
                                            "
                                        ></span>
                                        <!-- /ko -->

                                    </dd>
                                    <!-- /ko -->
                                </dl>
                            </div>
                        </div>
                        <div class="form-body">
                        </div>
                    </div>
                    <div class="w-form-body">
                        <strong class="form-sub-title">Specifications</strong>
                    </div>
                    <div class="w-form-body">
                        <div class="form-body">

                        <!-- ko if: brandId -->
                            <!-- ko if: showResetOrderButton -->
                            <div class="form-group row start">
                                <p class="form-text modify">The tag specification fields follow a brand specific order. This can be reset to follow the network order.</p>
                            </div>
                            <!-- /ko -->
                            <!-- ko ifnot: showResetOrderButton -->
                            <div class="form-group row start">
                                <p class="form-text default">The tag specification fields follow the network order.</p>
                            </div>
                            <!-- /ko -->
                        <!-- /ko -->

                            <div class="form-group">
                                <table class="list-action full-width">
                                    <thead>
                                        <tr style="background-color: #8a8a8a">
                                            <th>
                                                <span>Field Name</span>
                                            </th>
                                             <th>
                                                <span>Type</span>
                                            </th>
                                            <th data-bind="visible: permissions()['vignettes'].read">
                                                <span>Reference</span>
                                            </th>
                                            <th>
                                                <span>Position</span>
                                            </th>
                                            <!-- ko if: brandId -->
                                            <th>
                                                <span>Available for Use</span>
                                            </th>
                                            <!-- /ko -->

                                            <!-- ko if: groupings() && groupings().length > 0 -->
                                            <th>
                                                <span>Grouping</span>
                                            </th>
                                            <!-- /ko -->
                                        </tr>
                                    </thead>
                                    <tbody data-bind="foreach: specifications">
                                        <tr>
                                        <tr>
                                            <td>
                                                <span class="" data-bind="text: label">
                                            </td>
                                            <td>
                                                <span data-bind="text: dataType">
                                            </td>
                                            <td data-bind="visible: $parent.permissions()['vignettes'].read">
                                                <span data-bind="text: reference ? '[[' + reference + ']]' : ''"></span>
                                            </td>
                                             <td class="align-center">

                                                <!-- ko ifnot: $parent.brandId  -->
                                                   <span data-bind="text: position"></span>
                                                <!-- /ko -->

                                                <!-- ko if: $parent.brandId  -->
                                                <span data-bind="text: extra.position"></span>
                                                <!-- /ko -->

                                            </td>
                                            <!-- ko if: $parent.brandId  -->
                                                <td class="align-center">
                                                    <span data-bind="text: extra.isEnabled ? 'Enabled' : 'Disabled'"></span>
                                                </td>
                                            <!-- /ko -->
                                            <!-- ko if: $parent.groupings() && $parent.groupings().length > 0 -->
                                                <td class="align-center"><span data-bind="text: grouping ? grouping.name : ''"></span></td>
                                            <!-- /ko -->
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                    </div>
                `;
    }

    protected initPartial(): void {

    }

    protected getTemplateName(): string {

        return "tagTypesView_template";
    }

    protected buildViewModel(): any {

        let self = this;

        return {
            id: ko.observable(""),
            name: ko.observable(""),
            brandOwner: ko.observable(null),
            productSchemaTemplate: ko.observable(null),
            productSchemaTemplateName: ko.observable(""),
            productSchemaTemplateId: ko.observable(),
            datasetName: ko.observable(""),
            showResetOrderButton: ko.observable(false),
            specifications: ko.observableArray(),
            groupings: ko.observableArray([]),
            description: ko.observable(""),
            permissions: ko.observableArray(this.initPermissions(['tag_type_edit', 'vignettes'])),
            brandId: ko.observable(undefined),
            onClickEdit: function (data, event) {
                self.onClickEdit(data);
            },
            onClickCancel: function (data, event) {
                self.onClickCancel();
            },
        }
    };

    public onClickEdit(data) {

        this.caller.edit(data.id());
    }

    public onClickCancel() {

        this.caller.cancel();
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions);
    }

    public setId(id): void {

        this.getTemplateViewModel().id(id);
    }

    public setGroupings(groupings) {

        this.getTemplateViewModel().groupings(groupings);

    }

    public setBrandOwner(brandOwner: emaki_brand|null): void {
        this.getTemplateViewModel().brandOwner(brandOwner? brandOwner : null);
    }

    public setProductSchemaTemplate(productSchemaTemplate): void {

        this.getTemplateViewModel().productSchemaTemplate(productSchemaTemplate);
    }

    public setProductSchemaTemplateName(productSchemaTemplateName): void {

        this.getTemplateViewModel().productSchemaTemplateName(productSchemaTemplateName);
    }

    public setProductSchemaTemplateId(productSchemaTemplateId): void {

        this.getTemplateViewModel().productSchemaTemplateId(productSchemaTemplateId);
    }

    public setDatasetName(datasetName): void {

        this.getTemplateViewModel().datasetName(datasetName);
    }

    public setName(name): void {

        this.getTemplateViewModel().name(name);
    }

    public setDescription(description): void {

        this.getTemplateViewModel().description(description);
    }


    public setSpecifications(specifications) {

        this.getTemplateViewModel().specifications(specifications);
        this.detectOrderStatus(specifications);
    }


    private detectOrderStatus(specifications): void {

        let showResetOrderButton = false;
        if (this.isBrand()) {

            let saved = specifications.filter((s) => s.extra.id != null);
            if (saved.length > 0) {
                showResetOrderButton = true;
            }
        }

        this.getTemplateViewModel().showResetOrderButton(showResetOrderButton);
    }

    public setBrandId(brandId?: number): void {

        this.getTemplateViewModel().brandId(brandId);
    }


    public getBrandId(): number {

        return this.caller.getBrandId();
    }

    public isBrand(): boolean {

        return this.caller.isBrand();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/tagTypesView_template.ts